import { fireLogEvent, SpecType, UserActions, Components, sendRioEvent } from '@chegg/commerce-utils';
import { useEffect } from 'react';
var useSendResumeRestartEvent = function useSendResumeRestartEvent(_ref) {
  var isRioInitialized = _ref.isRioInitialized,
    action = _ref.action,
    namespace = _ref.namespace,
    externalId = _ref.externalId,
    priceWithoutCurrency = _ref.priceWithoutCurrency,
    currencyCode = _ref.currencyCode,
    sendRioViewEvents = _ref.sendRioViewEvents;
  useEffect(function () {
    if (!isRioInitialized) return;
    // Rio Logging: Resume/Restart component view
    var componentName = action === UserActions.RESUME || action === UserActions.REVOKE_PENDING_PAUSE ? Components.RESUME_SUBSCRIPTION : Components.RESTART_SUBSCRIPTION;
    sendRioEvent({
      info: componentName,
      specType: SpecType.COMPONENT_VIEW,
      callback: fireLogEvent,
      namespace: namespace,
      product_details: [{
        product_id: externalId || /* istanbul ignore next */'',
        display_price: Number(priceWithoutCurrency),
        product_type: null,
        quantity: 1,
        currency_code: currencyCode
      }],
      force: false
    });

    // TODO: Remove after CS endgame
    sendRioViewEvents && sendRioEvent({
      info: componentName,
      specType: SpecType.PAGE_VIEW,
      callback: fireLogEvent,
      namespace: namespace,
      force: false
    });
  }, [isRioInitialized]);
};
export default useSendResumeRestartEvent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/hooks/useSendResumeRestartEvent.js
// module id = 5214
// module chunks = 11